import { DELETE, GET, PATCH, POST } from '../../common/common.service'
import endpointsMadeFuel from './endpoints'

export const MadeService = {
  getAll: async ({ filter, sort, limit, skip, dateFrom, dateTo }) =>
    GET(
      endpointsMadeFuel.LOAD({
        filter,
        sort,
        limit,
        skip,
        dateFrom,
        dateTo,
      }),
    ),
  getAllLast: async ({ filter, sort, limit, skip }) =>
    GET(endpointsMadeFuel.LOAD_LAST({ filter, sort, limit, skip })),
  getAllByOwnSttion: async ({ id, filter, sort, limit, skip }) =>
    GET(
      endpointsMadeFuel.LOAD_BY_OWN_STATION({ id, filter, sort, limit, skip }),
    ),
  create: async (body) => POST(endpointsMadeFuel.CREATE, body),
  getById: async (id) => GET(endpointsMadeFuel.BY_ID(id)),
  update: async ({ _id, body }) =>
    PATCH(endpointsMadeFuel.BY_ID(_id), body, false),
  remove: async (id) => DELETE(endpointsMadeFuel.BY_ID(id)),
}
